import { NotificationTopicOwnersSettingsSection } from "@/components/NotificationTopicOwnersSettingsSection";
import { PageTitleWithHelp } from "@/components/ui/title-help";
import { apiFetch } from "@/lib/api";
import { HUB_NOTIFICATION_TOPIC_LABELS } from "@/lib/notificationsApi";
import { useHubModuleAdmin } from "@/lib/useHubModuleAdmin";

import { DocumentCollectionsPage } from "./DocumentCollectionsPage";
import { DocumentInboundEmailAllowlistSection } from "./DocumentInboundEmailAllowlistSection";
import { DocumentKindsSettingsSection } from "./DocumentKindsSettingsSection";

const NOTIFICATION_STAFF_USERS_QUERY_KEY = ["notifications", "staff-user-options"] as const;

function fetchNotificationStaffUsers(): Promise<{
  users: Array<{ userId: string; email: string; displayName: string | null }>;
}> {
  return apiFetch("/api/notifications/staff-user-options");
}

export function DocumentSettingsPage() {
  const canEdit = useHubModuleAdmin("documents");

  return (
    <div className="space-y-10">
      <header>
        <PageTitleWithHelp hoverHint="Document types (labels and hints), inbound drawings@ senders, product collections, relationships, and member part numbers. Changes require Document Control module administrator access (same tier as other hub Settings pages).">
          Document Control settings
        </PageTitleWithHelp>
      </header>

      <DocumentKindsSettingsSection />

      <DocumentInboundEmailAllowlistSection canEdit={canEdit} />

      <NotificationTopicOwnersSettingsSection
        topic="document_request"
        title={`${HUB_NOTIFICATION_TOPIC_LABELS.document_request} topic owners`}
        hoverHint="Hub users in this topic owner group receive in-app notifications for new document access and missing-document requests, and may claim ownership of open requests."
        canEdit={canEdit}
        userOptionsQueryKey={NOTIFICATION_STAFF_USERS_QUERY_KEY}
        fetchUserOptions={fetchNotificationStaffUsers}
        readOnlyHoverHint="Document Control administrators can edit this topic owner group."
      />

      <section className="space-y-4">
        <DocumentCollectionsPage />
      </section>
    </div>
  );
}
